// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e6A5a","title":"styles_title__Jy6Fm"};